import request from './request';

const mediaService = {
    list: (show, search, fileType, page, pageSize) => {
        return request({
            method: "get",
            url: `media/${encodeURI(show)}/list?${new URLSearchParams({ search, page, fileType, pageSize }).toString()}`
        });
    },
    files: (show, id) => {
        return request({
            method: "get",
            url: `media/${encodeURI(show)}/${id}/files`
        })
    },
    videoPlatformInfo: (show, id) => {
        return request({
            method: "get",
            url: `media/${encodeURI(show)}/${id}/videoplatforminfo`
        })
    },
    updateDuration: (show, id) => {
        return request({
            method: "put",
            url: `media/${encodeURI(show)}/${id}/updateduration`
        })
    }
};

export default mediaService;